/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  TextField,
  Text,
  View,
  SelectField,
} from "@aws-amplify/ui-react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Leads } from "../models";
import { fetchByPath, validateField } from "../utils/validation";
import { optionDiscarded } from "../utils/optionDiscarded";
import { DataStore } from "aws-amplify";
import Swal from "sweetalert2";
import LeadsContext from "../context/leads";
import { useContext, useEffect } from "react";
import moment from "moment";
import { saveCreateEventAsesor } from "../helpers/mutations";

export default function LeadsUpdateForm(props) {
  const {
    id: idProp,
    leads,
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    onToggleTab,
    user,
    userName,
    ...rest
  } = props;

  const {
    optZip,
    optBranch,
    obtainSuburb,
    obtainBranch,
    getAdress,
    obtAdress,
    setObtAdress,
    collsActive,
    FilterCollsID,
    collaboratorID,
    optCollaborators,  
    obtainCollaborators, 
    FilterBranchName,
    branchName,
  } = useContext(LeadsContext);

  let date = new Date();
  const dateRegister = moment(date, "DD-MM-YYYY HH:mm").format(
    "DD-MM-YYYY HH:mm"
  );
 
  const ShowAlert = () => {
    
    if (optBranch[0]?.id === undefined && status == 1) {
      Swal.fire({
        icon: "warning",
        text: "Por el momento, no hay una sucursal cercana",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#272D5D",
      }).then((result) => {
        if (result.isConfirmed) {
          onToggleTab(1);
        }
      });
    } else if (status == 1 || status == 3) {
      if (status == 3) {
        CreateEvent(
          idAdvicer,
          idAdvicer,
          idAdvicer,
          `Contactar a ${name} ${firstLastName} al teléfono ${phone1}`,
          date,
          date,
          branch,
          id
        );
      }
      Swal.fire({
        icon: "success",
        text: "El lead se ha Asignado con exito",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#272D5D",
      }).then((result) => {
        if (result.isConfirmed) {
          onToggleTab(1);
        }
      });
    } else if (status == 2 || status == 4) {
      Swal.fire({
        icon: "warning",
        text: "El lead se ha Desacartado",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#272D5D",
      }).then((result) => {
        if (result.isConfirmed) {
          onToggleTab(1);
        }
      });
    } else {
      Swal.fire({
        icon: "info",
        text: 'El lead aún se mantiene en "Por asignar"',
        confirmButtonText: "Entendido",
        confirmButtonColor: "#272D5D",
      }).then((result) => {
        if (result.isConfirmed) {
          onToggleTab(1);
        }
      });
    }
  };

  const CreateEvent = async (
    idEmployee,
    businessKey,
    idResponsable,
    description,
    startDate,
    endDate,
    address,
    id
  ) => {
    console.log(
      idEmployee.toString(),
      businessKey.toString(),
      idResponsable.toString(),
      description,
      moment(startDate, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm"),
      moment(endDate, "DD-MM-YYYY HH:mm")
        .add(1, "days")
        .format("DD-MM-YYYY HH:mm"),
      address,
      id
    );
    saveCreateEventAsesor(
      idEmployee.toString().trim(),
      businessKey.toString().trim(),
      idResponsable.toString().trim(),
      description.trim(),
      moment(startDate, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm"),
      moment(endDate, "DD-MM-YYYY HH:mm")
        .add(1, "days")
        .format("DD-MM-YYYY HH:mm"),
      address.trim(),
      id.trim()
    ).then(function (responseSaves) {
      if (responseSaves === "error") {
        console.log("error", responseSaves);
      } else {
        setIdEvent(responseSaves);
        console.log(responseSaves);
      }
    });
  };

  const initialValues = {
    name: "",
    firstLastName: "",
    secondLastName: "",
    birth: "",
    adress: "",
    cp: "",
    suburb: "",
    municipio: "",
    estado: "",
    pais: "",
    phone1: "",
    email: "",
    curp: "",
    comments: "",
    channel: "",
    dateRegistry: "",
    idBranch: "",
    branch: "",
    detail: "",
    Who: "",
    conekta: "",
    dateManager: "",
    fase: "",
    CommentManage: "",
    idManager: "",
    NameManager: "",
    dateAsignation: "",
    status: 0,
    idAdvicer: "",
    advicer: "",
    dateAtencion: "",
    isContacted: 0,
    idEvent: "",
    isReassigned: 0,
  };

  const [id, setId] = React.useState(initialValues.id);
  const [name, setName] = React.useState(initialValues.name);
  const [firstLastName, setFirstLastName] = React.useState(
    initialValues.firstLastName
  );
  const [secondLastName, setSecondLastName] = React.useState(
    initialValues.secondLastName
  );
  const [phone1, setPhone1] = React.useState(initialValues.phone1);
  const [birth, setBirth] = React.useState(initialValues.birth);
  const [cp, setCp] = React.useState(initialValues.cp);
  const [suburb, setSuburb] = React.useState(initialValues.suburb);
  const [other, setOther] = React.useState(initialValues.suburb);
  const [adress, setAdress] = React.useState(initialValues.adress);
  const [municipio, setMunicipio] = React.useState(initialValues.municipio);
  const [estado, setEstado] = React.useState(initialValues.estado);
  const [pais, setPais] = React.useState(initialValues.pais);

  const [curp, setCurp] = React.useState(initialValues.curp);
  const [email, setEmail] = React.useState(initialValues.email);
  const [dateRegistry, setDateRegistry] = React.useState(
    initialValues.dateRegistry
  );
  const [channel, setChannel] = React.useState(initialValues.channel);
  const [conekta, setConekta] = React.useState(initialValues.conekta);
  const [comments, setComments] = React.useState(initialValues.comments);
  const [dateAsignation, setDateAsignation] = React.useState(
    initialValues.dateAsignation
  );

  const [idBranch, setIdBranch] = React.useState(initialValues.idBranch);
  const [branch, setBranch] = React.useState(initialValues.branch);
  const [advicer, setAdvicer] = React.useState(initialValues.advicer);
  const [dateAtencion, setDateAtencion] = React.useState(
    initialValues.dateAtencion
  );
  const [detail, setDetail] = React.useState(initialValues.detail);
  const [fase, setFase] = React.useState(initialValues.fase);
  const [Who, setWho] = React.useState(initialValues.Who);
  const [status, setStatus] = React.useState(initialValues.status);
  const [dateManager, setDateManager] = React.useState(
    initialValues.dateManager
  );
  const [idManager, setIdManager] = React.useState(initialValues.idManager);
  const [idAdvicer, setIdAdvicer] = React.useState(initialValues.idAdvicer);
  const [CommentManage, setCommentManage] = React.useState(
    initialValues.CommentManage
  );
  const [NameManager, setNameManager] = React.useState(
    initialValues.NameManager
  );
  const [isContacted, setIsContacted] = React.useState(
    initialValues.isContacted
  );
  const [isReassigned, setIsReassigned] = React.useState(
    initialValues.isReassigned
  );
  const [idEvent, setIdEvent] = React.useState(initialValues.idEvent);

  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = leadsRecord
      ? { ...initialValues, ...leadsRecord }
      : initialValues;
    //setOptZip([]);
    //setOptBranch([]);
    setObtAdress([]);
    setId(cleanValues.id);
    setName(cleanValues.name);
    setFirstLastName(cleanValues.firstLastName);
    setSecondLastName(cleanValues.secondLastName);
    setBirth(cleanValues.birth);
    setAdress(cleanValues.adress);
    setPhone1(cleanValues.phone1);
    {
      cleanValues.email === null ? setEmail("") : setEmail(cleanValues.email);
    }
    setCp(cleanValues.adress?.cp);
    setAdress(cleanValues.adress);
    setSuburb(cleanValues.adress?.asentamiento);
    setMunicipio(cleanValues.adress?.municipio);
    setEstado(cleanValues.adress?.estado);
    setPais(cleanValues.adress?.pais);
    setCurp(cleanValues.curp);
    setComments(cleanValues.comments);
    setChannel(cleanValues.channel);
    setDateRegistry(cleanValues.dateRegistry);
    setIdBranch(cleanValues.idBranch);
    setBranch(cleanValues.branch);
    setDetail(cleanValues.detail);
    setWho(cleanValues.Who);
    setConekta(cleanValues.conekta);
    setDateManager(cleanValues.dateManager);
    setFase(cleanValues.fase);
    setCommentManage(cleanValues.CommentManage);
    setIdManager(cleanValues.idManager);
    setNameManager(cleanValues.NameManager);
    setDateAsignation(cleanValues.dateAsignation);
    setStatus(cleanValues.status);
    setIdAdvicer(cleanValues.idAdvicer);
    setAdvicer(cleanValues.advicer);
    setDateAtencion(cleanValues.dateAtencion);
    setIsContacted(cleanValues.isContacted);
    setIsReassigned(cleanValues.isReassigned);
    setIdEvent(initialValues.idEvent);
    setErrors({});
  };
  const [leadsRecord, setLeadsRecord] = React.useState(leads);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp ? await DataStore.query(Leads, idProp) : leads;
      setLeadsRecord(record);
    };
    queryData();
  }, [idProp, leads]);
  React.useEffect(resetStateValues, [leadsRecord]);

  const validations = {
    name: [{ type: "Required" }],
    firstLastName: [{ type: "Required" }],
    secondLastName: [],
    birth: [],
    adress: [],
    phone1: [{ type: "Required" }, { type: "Phone" }],
    email: [{ type: "Email" }],
    curp: [],
    comments: [],
    channel: [],
    dateRegistry: [],
    idBranch: [],
    branch: [],
    detail: [],
    Who: [],
    conekta: [],
    dateManager: [],
    fase: [],
    CommentManage: [],
    idManager: [],
    NameManager: [],
    dateAsignation: [],
    status: [],
    idAdvicer: [],
    advicer: [],
    dateAtencion: [],
    isContacted: [],
    idEvent: [],
    isReassigned: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value = getDisplayValue
      ? getDisplayValue(currentValue)
      : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };

  useEffect(() => {
    obtainSuburb(cp);
    obtainBranch(cp);
  }, [cp, obtainBranch, obtainSuburb]);

  useEffect(() => {
    getAdress(suburb);
    ObteinAdress();
  }, [suburb, obtAdress]);

  useEffect(() => {
    if (user === "Lider") {
      obtainCollaborators(idBranch)
      if (branch==null || branch === undefined){
        //FilterBranchName(idBranch)
        setBranch(branchName?.branchOfficeName)  
      }
    }
  }, [idBranch, status, branchName, optCollaborators]);

  console.log(adress)
  
  useEffect(() => {
    if (user != "Contact Center") {
      FilterCollsID(detail)
    }
  }, [detail, collaboratorID]);

  //console.log(optBranch)

  function ObteinAdress() {
    setMunicipio(obtAdress?.municipio ?? "");
    setEstado(obtAdress?.estado ?? "");
    setPais(obtAdress?.pais ?? "");
  }
  let updateAdrees = JSON.parse(
    `{\n   "cp":"${cp}",\n   "asentamiento":"${
      suburb === "otra" ? other : suburb
    }",\n   "municipio":"${municipio}",\n   "estado":"${estado}",\n   "pais":"${pais}"\n}`
  );
 
  console.log(status);
  console.log(id)

  return (
    <Grid
      as="form"
      rowGap="32px"
      columnGap="24px"
      templateColumns={{
        base: "1fr",
        small: "1fr",
        medium: "1fr 1fr 1fr",
      }}
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          name,
          firstLastName,
          secondLastName,
          birth,
          adress: updateAdrees,
          phone1,
          email,
          curp,
          comments,
          channel,
          dateRegistry,
          idBranch: status == 1 || (status == 3 && user === "Lider") ? optBranch[0]?.id : idBranch,
          branch: status == 1 || (status == 3 && user === "Lider") ? optBranch[0]?.branchOfficeName : branch,
          detail,
          Who: user,
          conekta: user === "Gerente" ? conekta: userName,
          dateManager: user === "Contact Center" ? dateManager : dateRegister,
          fase,
          CommentManage,
          idManager,
          NameManager: user != "Contact Center" ? userName : NameManager,
          dateAsignation: user != "Gerente" ? dateRegister : dateAsignation,
          status:
            status == 1 && optBranch[0]?.id === undefined
              ? 7
              : status == 10
              ? 1
              : parseInt(status),
          idAdvicer: status == 3 ? collaboratorID?.id : idAdvicer,
          advicer: status == 3 ? collaboratorID?.name : advicer,
          dateAtencion,
          isContacted,
          isReassigned: status == 3 ? isReassigned + 1 : isReassigned,
          idEvent,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        if (clearOnSuccess) {
          resetStateValues();
        }

        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value.trim() === "") {
              modelFields[key] = undefined;
            }
          });
          await DataStore.save(
            Leads.copyOf(leadsRecord, (updated) => {
              ShowAlert();
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "LeadsUpdateForm")}
      {...rest}
    >
      <View columnStart="1" columnEnd="-1">
        <Text>Datos Generales</Text>
        <Text fontWeight={600} fontSize="1.8em">
          {(`${name} ${firstLastName} ${secondLastName}`).toUpperCase()}
        </Text>
      </View>
      <TextField
        label="Nombre"
        isRequired={true}
        isReadOnly={false}
        value={name?.toUpperCase()}
        columnStart="1"
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name: value,
              firstLastName,
              secondLastName,
              birth,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              isReassigned,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={errors.name?.errorMessage}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <TextField
        label="Apellido paterno"
        isRequired={true}
        isReadOnly={false}
        value={firstLastName?.toUpperCase()}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName: value,
              secondLastName,
              birth,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              isReassigned,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.firstLastName ?? value;
          }
          if (errors.firstLastName?.hasError) {
            runValidationTasks("firstLastName", value);
          }
          setFirstLastName(value);
        }}
        onBlur={() => runValidationTasks("firstLastName", firstLastName)}
        errorMessage={errors.firstLastName?.errorMessage}
        hasError={errors.firstLastName?.hasError}
        {...getOverrideProps(overrides, "firstLastName")}
      ></TextField>
      <TextField
        label="Apellido materno"
        isRequired={false}
        isReadOnly={false}
        value={secondLastName?.toUpperCase()}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName: value,
              birth,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              isReassigned,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.secondLastName ?? value;
          }
          if (errors.secondLastName?.hasError) {
            runValidationTasks("secondLastName", value);
          }
          setSecondLastName(value);
        }}
        onBlur={() => runValidationTasks("secondLastName", secondLastName)}
        errorMessage={errors.secondLastName?.errorMessage}
        hasError={errors.secondLastName?.hasError}
        {...getOverrideProps(overrides, "secondLastName")}
      ></TextField>
      <TextField
        label="Fecha de nacimiento"
        variation="quiet"
        isRequired={false}
        isReadOnly={false}
        type="date"
        value={birth}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth: value,
              adress,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.birth ?? value;
          }
          if (errors.birth?.hasError) {
            runValidationTasks("birth", value);
          }
          setBirth(value);
        }}
        onBlur={() => runValidationTasks("birth", birth)}
        errorMessage={errors.birth?.errorMessage}
        hasError={errors.birth?.hasError}
        {...getOverrideProps(overrides, "birth")}
      ></TextField>
      <TextField
        label="Teléfono de contacto"
        variation="quiet"
        isRequired={true}
        isReadOnly={false}
        type="tel"
        value={phone1}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth,
              adress,
              phone1: value,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.phone1 ?? value;
          }
          if (errors.phone1?.hasError) {
            runValidationTasks("phone1", value);
          }
          setPhone1(value);
        }}
        onBlur={() => runValidationTasks("phone1", phone1)}
        errorMessage={errors.phone1?.errorMessage}
        hasError={errors.phone1?.hasError}
        {...getOverrideProps(overrides, "phone1")}
      ></TextField>
      <View>
        <TextField
          label="CURP"
          isRequired={false}
          isReadOnly={false}
          variation="quiet"
          value={curp}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp: value,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.curp ?? value;
            }
            if (errors.curp?.hasError) {
              runValidationTasks("curp", value);
            }
            setCurp(value);
          }}
          onBlur={() => runValidationTasks("curp", curp)}
          errorMessage={errors.curp?.errorMessage}
          hasError={errors.curp?.hasError}
          {...getOverrideProps(overrides, "curp")}
        ></TextField>
        <Text
          margin="0.3rem"
          fontSize="0.8em"
          color="#5C6670"
          fontStyle="italic"
        >
          Opcional
        </Text>
      </View>
      <View>
        <TextField
          label="Correo electrónico"
          isRequired={false}
          isReadOnly={false}
          variation="quiet"
          value={email}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email: value,
                curp,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.email ?? value;
            }
            if (errors.email?.hasError) {
              runValidationTasks("email", value);
            }
            setEmail(value);
          }}
          onBlur={() => runValidationTasks("email", email)}
          errorMessage={errors.email?.errorMessage}
          hasError={errors.email?.hasError}
          {...getOverrideProps(overrides, "email")}
        ></TextField>
        <Text
          margin="0.3rem"
          fontSize="0.8em"
          color="#5C6670"
          fontStyle="italic"
        >
          Opcional
        </Text>
      </View>
      <TextField
        label="Código postal"
        variation="quiet"
        columnStart="1"
        isRequired={status == 1 ? true : false}
        isReadOnly={false}
        value={cp}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth,
              adress,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.cp ?? value;
          }
          setCp(value);
        }}
        {...getOverrideProps(overrides, "cp")}
      ></TextField>
      <SelectField
        label="Colonia"
        isRequired={status == 1 ? true : false}
        placeholder="Seleccionar"
        defaultValue={suburb}
        value={suburb}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth,
              adress,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            value = rest?.suburb ?? value;
          }
          setSuburb(value);
        }}
        {...getOverrideProps(overrides, "suburb")}
      >
        {optZip?.map((option) => (
          <option key={option.id} value={option.asentamiento}>
            {option.asentamiento}
          </option>
        ))}
        <option value="otra">Otra</option>
      </SelectField>
      {suburb === "otra" && (
        <TextField
          label="Otra colonia"
          isRequired={false}
          isReadOnly={false}
          variation="quiet"
          placeholder="Seleccionar"
          value={other}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.other ?? value;
            }
            setOther(value);
          }}
        ></TextField>
      )}
      {user === "Lider" && (
        <SelectField
          label="Sucursal"
          placeholder="Seleccionar"
          isRequired={status == 1 ? true : false}
          value={idBranch}
          defaultValue={idBranch}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp,
                comments,
                channel,
                dateRegistry,
                idBranch: value,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.idBranch ?? value;
            }
            //setBranch(optBranch[]?.branchOfficeName);
            setIdBranch(value);
            FilterBranchName(value);
            
          }}
          {...getOverrideProps(overrides, "branch")}
        >
         { optBranch.map((option, idx) => (
              <option key={idx} value={option.id}>
                {option.branchOfficeName}
              </option>
            ))}
        </SelectField>
      )}
      
      <View columnStart="1" columnEnd="2">
        <SelectField
          label="Acción"
          placeholder="Seleccionar"
          isRequired={user != "Contact Center" ? true : false}
          value={status}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status: value,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.status ?? value;
            }
            setStatus(value);
          }}
          {...getOverrideProps(overrides, "status")}
        >
          {user != "Gerente" & status < 3  &&  <option value={1}>Asignar a sucursal</option>}
           
          {user != "Contact Center"  &&  
          <>
          {user == "Gerente"  && <option value={3}>Asignar asesor</option>}
          {status > 1 & user == "Lider" && <option value={3}>Asignar asesor</option>}
          {user == "Gerente"  && <option value={10}>Cambiar de sucursal</option>}
          </>}
          <option value={user === "Contact Center" ? 2 : 4}>Descartar</option>
        </SelectField>
      </View>
      <SelectField
        label="Detalle"
        isRequired={status >= 2 ? true : false}
        placeholder="Seleccionar"
        isDisabled={status >= 2 || status == 10 ? false : true}
        value={detail}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth,
              adress,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail: value,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.detail ?? value;
          }
          setDetail(value);
          {
            status == 3 && setIdAdvicer(value);
          }
        }}
        {...getOverrideProps(overrides, "detail")}
      >
        {status == 3 
          ? collsActive.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))
          : status == 10
          ? optBranch.map((option) => (
              <option key={option.id} value={option.branchOfficeName}>
                {option.branchOfficeName}
              </option>
            ))
          : optionDiscarded.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
      </SelectField>
      {user === "Contact Center" ? (
        <TextField
          label="Comentarios"
          variation="quiet"
          columnStart={{ base: "1", small: "3" }}
          columnEnd="-1"
          isRequired={false}
          isReadOnly={false}
          value={comments}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp,
                comments: value,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.comments ?? value;
            }
            if (errors.comments?.hasError) {
              runValidationTasks("comments", value);
            }
            setComments(value);
          }}
          onBlur={() => runValidationTasks("comments", comments)}
          errorMessage={errors.comments?.errorMessage}
          hasError={errors.comments?.hasError}
          {...getOverrideProps(overrides, "comments")}
        ></TextField>
      ) : (
        <TextField
          label="Comentarios"
          variation="quiet"
          isRequired={false}
          isReadOnly={false}
          columnStart={{ base: "1", small: "3" }}
          columnEnd="-1"
          value={CommentManage}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage: value,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.CommentManage ?? value;
            }
            if (errors.CommentManage?.hasError) {
              runValidationTasks("CommentManage", value);
            }
            setCommentManage(value);
          }}
          onBlur={() => runValidationTasks("CommentManage", CommentManage)}
          errorMessage={errors.CommentManage?.errorMessage}
          hasError={errors.CommentManage?.hasError}
          {...getOverrideProps(overrides, "CommentManage")}
        ></TextField>
      )}
      <Flex
        justifyContent="end"
        columnStart="1"
        columnEnd="-1"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Borrar Cambios"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || leads)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children={
              status == 1 ? "Asignar" : status == 2 ? "Descartar" : "Guardar"
            }
            type="submit"
            variation={status == 2 ? "destructive" : "primary"}
            isDisabled={
              !(idProp || leads) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
